export default __webpack_public_path__ + "static/media/logo-default-color.e76fca81.png";